// Runtime file for Shared Runtime support
// This file enables Shared Runtime functionality in Office Add-ins

Office.onReady(() => {
	console.log("Shared Runtime initialized")
})

// Export any shared functionality that needs to be available across the add-in
export {}
